var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 35,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 35,
    rx: 5.5,
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5763 7.45076C27.8106 7.21645 28.1905 7.21645 28.4249 7.45076L32.9249 11.9508C33.1592 12.1851 33.1592 12.565 32.9249 12.7993C32.6905 13.0336 32.3106 13.0336 32.0763 12.7993L28.6004 9.32336V19.125C28.6004 19.4564 28.3318 19.725 28.0004 19.725C27.669 19.725 27.4004 19.4564 27.4004 19.125V9.32375L23.9249 12.7993C23.6905 13.0336 23.3106 13.0336 23.0763 12.7993C22.842 12.565 22.842 12.1851 23.0763 11.9508L27.5763 7.45076ZM20.1254 17.35C19.8354 17.35 19.6004 17.5851 19.6004 17.875V27C19.6004 27.29 19.8354 27.525 20.1254 27.525H35.8754C36.1653 27.525 36.4004 27.29 36.4004 27V17.875C36.4004 17.5851 36.1653 17.35 35.8754 17.35H33.6254C33.294 17.35 33.0254 17.0814 33.0254 16.75C33.0254 16.4187 33.294 16.15 33.6254 16.15H35.8754C36.8281 16.15 37.6004 16.9223 37.6004 17.875V27C37.6004 27.9527 36.8281 28.725 35.8754 28.725H20.1254C19.1727 28.725 18.4004 27.9527 18.4004 27V17.875C18.4004 16.9223 19.1727 16.15 20.1254 16.15H22.3754C22.7068 16.15 22.9754 16.4187 22.9754 16.75C22.9754 17.0814 22.7068 17.35 22.3754 17.35H20.1254Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.60c2886480135021f82c48f5aacf93b2.svg";
export { ForwardRef as ReactComponent };